// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* customStyles.css */
.btn-success {
    background-color: #B99278; /* Change to your desired color */
    border-color: #B99278; /* Adjust the border if needed */
  }
  
  .btn-success:hover {
    background-color:  #6B3F4F; /* Optional hover effect */
    border-color:  #6B3F4F;
  }

  .btn-secondary{
    background-color: #F4DFB9;
    border-color:  #F4DFB9;
    color: #5a5a5a;
  }
/* customStyles.css */
.btn-secondary.active {
    background-color: #6c757d; /* Change to your desired active background color */
    color: #ffffff; /* Change to your desired active text color */
    border-color: #6c757d; /* Change border color if needed */
  }
  
  .btn-secondary.active:hover {
    background-color: #5a6268; /* Optional hover effect for active state */
  }
 

`, "",{"version":3,"sources":["webpack://./src/pages/style.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,yBAAyB,EAAE,iCAAiC;IAC5D,qBAAqB,EAAE,gCAAgC;EACzD;;EAEA;IACE,0BAA0B,EAAE,0BAA0B;IACtD,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;AACF,qBAAqB;AACrB;IACI,yBAAyB,EAAE,mDAAmD;IAC9E,cAAc,EAAE,6CAA6C;IAC7D,qBAAqB,EAAE,kCAAkC;EAC3D;;EAEA;IACE,yBAAyB,EAAE,2CAA2C;EACxE","sourcesContent":["/* customStyles.css */\n.btn-success {\n    background-color: #B99278; /* Change to your desired color */\n    border-color: #B99278; /* Adjust the border if needed */\n  }\n  \n  .btn-success:hover {\n    background-color:  #6B3F4F; /* Optional hover effect */\n    border-color:  #6B3F4F;\n  }\n\n  .btn-secondary{\n    background-color: #F4DFB9;\n    border-color:  #F4DFB9;\n    color: #5a5a5a;\n  }\n/* customStyles.css */\n.btn-secondary.active {\n    background-color: #6c757d; /* Change to your desired active background color */\n    color: #ffffff; /* Change to your desired active text color */\n    border-color: #6c757d; /* Change border color if needed */\n  }\n  \n  .btn-secondary.active:hover {\n    background-color: #5a6268; /* Optional hover effect for active state */\n  }\n \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
